import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsShopify() {
    const features = [
        {
            title: 'Shopify Store Design & Development',
            description:
                'Moweb provides full-service Shopify design and development to understand your company\'s goals, target market, and specific needs. We create and design custom Shopify stores to capture the essence of the brand while also engaging the audience.',
            icon: '/img/technology/ic-shopify-store-design.svg',
        },
        {
            title: 'Custom Shopify Website Development',
            description:
                'As a full-service Shopify development company, we meet a wide range of e-commerce website needs with customized solutions. We plan our development around your e-commerce goals and deliver a successful e-commerce store.',
            icon: '/img/technology/ic-cutome-shopify-website.svg',
        },
        {
            title: 'Shopify App Integration & Configuration',
            description:
                'Our Shopify programmers specialize in integrating and configuring your e-commerce store with various front-end and back-end systems using Shopify APIs. To meet the specific requirements of our users, we connect data, systems, services, and people.',
            icon: '/img/technology/ic-app-integration.svg',
        },
        {
            title: 'Shopify Theme Development',
            description:
                "Our dedicated Shopify developers have experience creating or customizing highly responsive themes and delivering striking UIs. Also, to design and develop mobile-ready themes that can improve user experiences, we adhere to Shopify standards.",
            icon: '/img/technology/ic-shopify-theme.svg',
        },
        {
            title: 'Shopify Plus Development',
            description:
                'Our Shopify Plus development services are created for businesses that require a more robust and scalable e-commerce platform. We offer custom solutions that cater to unique business needs, ensuring that Shopify Plus stores are visually appealing, user-friendly, and optimized for conversions.',
            icon: '/img/technology/ic-shopify-plus-store.svg',
        },
        {
            title: 'Maintenance & Upgrade',
            description:
                'We offer full Shopify maintenance and support services, including platform upgrades to the latest iteration, bug fixes, and performance optimization. With top-tier payment gateways, shopping carts, APIs, and third-party apps, we enhance your website\'s functionality.',
            icon: '/img/technology/ic-shopify-maintence-upgrade.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
